import type { FC } from "react";
import { RouterProvider } from "react-router";

import { router } from "@/routes";
import { I18nSplashScreenProvider } from "@/routes/I18nSplashScreenProvider";

import "./i18n/i18n";

import "./assets/fonts/montserrat/stylesheet.css";
import "./assets/fonts/roboto/stylesheet.css";
import "./assets/fonts/eudoxus-sans/stylesheet.css";
// import "./assets/fonts/Inter/stylesheet.css";
import "./assets/fonts/Inter/stylesheet.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./index.css";

const App: FC = () => {
  return (
    <I18nSplashScreenProvider>
      <RouterProvider router={router} />
    </I18nSplashScreenProvider>
  );
};

export default App;
